import { ChevronDown } from "lucide-react"

export default function Card({ isOpen = false, onToggle, question, answer }) {
  return (
    <article
      className={`group rounded-lg border border-zi-border-light dark:border-zi-border-light/10 ${
        isOpen
          ? "dark:bg-zi-inputbg-dark/70 dark:border-zi-border-light/20"
          : "bg-zi-bg2-light dark:bg-zi-bg2-dark"
      }`}
    >
      <button
        type="button"
        aria-expanded={isOpen}
        className="flex h-auto w-full items-center justify-between gap-2.5 px-3 py-3 text-start sm:px-6 sm:py-4"
        onClick={() => {
          if (typeof onToggle === "function") {
            onToggle()
          }
        }}
      >
        <h3
          className={`text-wrap text-start text-sm font-medium sm:text-base ${
            isOpen
              ? "text-zi-text-light dark:text-zi-text-dark"
              : "text-zi-text-light/80 dark:text-zi-text-dark/80"
          }`}
        >
          {question}
        </h3>
        <span
          className={`flex shrink-0 rounded-full ${
            isOpen
              ? "text-zi-text-light dark:text-zi-text-dark"
              : "text-zi-text-light/50 dark:text-zi-text-dark/50"
          }`}
        >
          <ChevronDown className={`size-4 ${isOpen ? "rotate-180" : ""}`} />
        </span>
      </button>

      {isOpen && (
        <div className="pb-3 pl-9 pr-3 pt-0 text-justify text-sm leading-loose text-zi-text-light/70 dark:text-zi-text-dark/70 sm:pb-4 sm:pl-12 sm:pr-6">
          {answer}
        </div>
      )}
    </article>
  )
}
